export default function Spinner() {
  return <div className="spinner-border spinner-border-sm"></div>;
}
